import {useInView} from "framer-motion"
import {useEffect, useRef} from "react"

function Home({setPagesInView}) {
    const ref = useRef(null)
    const isInView = useInView(ref)
    useEffect(() => {
        setPagesInView(prevPagesInView => {
            let newPagesInView = [...prevPagesInView];
            newPagesInView[0] = isInView;
            return newPagesInView;
        });
    }, [isInView, setPagesInView])
    return (
        <div className="PageContainer">
            <div ref={ref} style={{maxWidth: "750px", display: "flex", flexFlow: "column wrap", fontSize: "40px"}}>
                "Simplicity is prerequisite for reliability."
                <p style={{fontSize: "20px", marginTop: "20px"}}>~ Edsger Dijkstra</p>
            </div>
        </div>
    );
}

export default Home;

